export default __webpack_public_path__ + "static/media/bootstrap-plain.7f45dd81.svg";